import { render } from "./Contact.vue?vue&type=template&id=e75305ea&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-e75305ea"

export default script